<template>
  <div id="app">
    <router-view/>
    <div class="fl" id="fl" @mouseenter="flMouseenter" @mouseleave="flMouseleave" v-show="isShowFl">
      <div class="fl-close" @click="isShowFl=false"></div>
      <a href="http://jrghlaomo.kjcxchina.com/Index/index" target="_blank">
        <img src="@/assets/float-img2.png" class="fl-img" id="flImg">
      </a>
  </div>
  </div>
</template>
<script>
export default {
  name: 'FL',
  data() {
    return {
      timer: '',   //定时器
      isShowFl: true,
      x: 1,
      y: 1,
    };
  },
  mounted() {
    // this.fL();
  },
  methods: {
    fL(){
      let _this = this;

      let chroX = document.documentElement.clientWidth;  //yemian整个的高宽
      let chroY = document.documentElement.clientHeight;

      let fl = document.getElementById('fl');
      let offsetLeft = fl.offsetLeft;  //盒子的位置
      let offsetTop = fl.offsetTop;

      this.timer = setInterval(function () {
        offsetLeft += _this.x;
        offsetTop += _this.y;
        
        fl.style.left = offsetLeft + 'px';
        fl.style.top = offsetTop + 'px';

        if (offsetTop + fl.offsetHeight > chroY || offsetTop < 0) {
          _this.y = -_this.y;
        }
        if (offsetLeft + fl.offsetWidth > chroX || offsetLeft < 0) {
          _this.x = -_this.x;
        }
      }, 10);
    },
    flMouseenter(){
      clearInterval(this.timer);
      this.timer = '';
    },
    flMouseleave(){
      this.fL();
    }
  },
  watch: {
    //监听路由判断换题
    $route() {
      if(this.$route.name == 'Index'){
        this.isShowFl = true;
        this.fL();
      }else{
        this.isShowFl = false;
        this.flMouseenter();
      }
    }
  }
}
</script>
<style lang="scss">
html, body, div, ul, li, input, button, img, textarea, p, h1, a{
  margin: 0;
  padding: 0;
  border: none;
  outline:none;
  -webkit-tap-highlight-color: transparent; //禁用按压时有背景颜色
  box-sizing: border-box;
}
body{
  color: #000;
}
li{
  list-style: none;
}
a{
  text-decoration: none;
}
img{
  display: block;
  object-fit: cover;
}
input::-webkit-input-placeholder{
  font-size: 14px;
  color: #999;
}
//去掉input自动填充的黄色背景
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}
//清除浮动
.clearfix::after {
	content: '';
	display: table;
	clear: both;
}
/* 兼容IE低版本 */
.clearfix {
	*zoom: 1;
}
//单行省略号
.a-single-ellipsis{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
//多行省略号
.vertical-ellipsis{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
//禁用双击选中
.disable-double-click-selected{
  -moz-user-select:none;/*火狐*/
  -webkit-user-select:none;/*webkit浏览器*/
  -ms-user-select:none;/*IE10*/
  -khtml-user-select:none;/*早期浏览器*/
  user-select:none;
}

.fl{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .fl-img{
    width: 400px;
    cursor: pointer;
  }
  .fl-close{
    width: 50px;
    height: 50px;
    background: url('@/assets/close.gif') no-repeat center center/100%;
    position: absolute;
    top: -50px;
    right: 0;
    cursor: pointer;
  }
}
</style>
